var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ETH"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9995 3V14.085L27.3745 18.2775L17.9995 3Z",
    fill: "#8FFCF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18 3L8.625 18.2775L18 14.085V3Z",
    fill: "#CABCF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.9995 25.4626V33.0001L27.3745 20.0251L17.9995 25.4626Z",
    fill: "#CBA7F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18 33.0001V25.4626L8.625 20.0251L18 33.0001Z",
    fill: "#74A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.9995 23.7151L27.3745 18.2778L17.9995 14.0852V23.7151Z",
    fill: "#CBA7F5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.625 18.2778L18 23.7151V14.0852L8.625 18.2778Z",
    fill: "#74A0F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 23.715L8.625 18.2775L18 3L27.3751 18.2775L18 23.715ZM9.2475 17.835L17.85 3.8175V14.01L9.2475 17.835ZM9.12 18.2175L17.85 14.34V23.28L9.12 18.2175ZM18.15 14.34V23.28L26.8725 18.2175L18.15 14.34ZM18.15 14.01L26.7525 17.835L18.15 3.8175V14.01Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 25.3424L8.625 20.0176L18 32.9999L27.3751 20.0176L18 25.3424ZM9.675 20.9551L17.85 25.6049V32.2801L9.675 20.9551ZM18.15 25.6049V32.2801L26.3251 20.9551L18.15 25.6049Z",
    fill: "#4A4A4A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvm);
export default __webpack_public_path__ + "static/media/evm.56bc0246c54740c3d9fdc81bd98b8924.svg";
export { ForwardRef as ReactComponent };